"use client";

import { useState } from "react";
import { ClerkProvider, useAuth } from "@clerk/nextjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConvexProviderWithClerk } from "convex/react-clerk";
import { posthog } from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

import { Toaster } from "@soonlist/ui/sonner";

import { BatchStatusToastContainer } from "~/components/BatchStatusToast";
import { WorkflowStatusToastContainer } from "~/components/WorkflowStatusToast";
import ContextProvider from "~/context/ContextProvider";
import { env } from "~/env";
import { convex } from "~/lib/convex";

if (typeof window !== "undefined" && process.env.NODE_ENV !== "development") {
  posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: `https://${env.NEXT_PUBLIC_VERCEL_PROJECT_PRODUCTION_URL}/app`,
    capture_pageview: false,
  });
}

export function PHProvider({ children }: { children: React.ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <ClerkProvider
      appearance={{
        variables: { colorPrimary: "rgb(90, 50, 251)", borderRadius: "16px" },
      }}
    >
      <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
        <QueryClientProvider client={queryClient}>
          <ContextProvider>
            {children}
            <Toaster />
            <WorkflowStatusToastContainer />
            <BatchStatusToastContainer />
          </ContextProvider>
        </QueryClientProvider>
      </ConvexProviderWithClerk>
    </ClerkProvider>
  );
}
